// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__3IgaB","productName":"Table_productName__1sSFZ"};